module.exports = __webpack_public_path__ + "img/NoMessages.c4891207.png";